import { getApplicantCorrectionsRequest } from './CorrectionActions';

// Correction
export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    // Correction edited => refresh corrections list
    socket.on('correction/edited', data => {
        console.log('Socket::: correction/edited', data);
        dispatch(getApplicantCorrectionsRequest(data.applicant));
    });
}
